import React, { useState, useEffect } from 'react';
import {
    Grid,
    MenuItem,
    TextField,
    Typography,
    InputLabel,
    Card,
    Select,
    Icon,
    Link,
} from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import SimpleFooter from "examples/Footers/SimpleFooter";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import routes from "routes";
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import Container from "@mui/material/Container";
import MKTypography from "components/MKTypography";
import Autocomplete from '@mui/material/Autocomplete';
import MKInput from 'components/MKInput';
import SearchIcon from "@mui/icons-material/Search";
import FormControl from '@mui/material/FormControl';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment-timezone';
import { LocationOn } from '@mui/icons-material';
import Logo from "assets/images/skill2.png";
import CompanyIcon from "assets/images/companyicon.png";
import Expectation from "assets/images/team_3082743.png";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { useLocation } from 'react-router-dom';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import Slider from '@mui/material/Slider';
import VirtualIcon from "assets/images/virtual.png";
import ClassroomIcon from "assets/images/classroom.png";
import { useNavigate } from 'react-router-dom';
import '../../../styles.css';


function valuetext(value) {
    return `${value}`;
}


const sidebarStyles = {
    width: '350px',
    // backgroundColor: 'rgba(0, 0, 50, 0.2)', // Blue with 50% transparency
    padding: '20px',
    color: 'white',
    borderRadius: '15px',
};

const Page = () => {
    // const styles = {
    //     gridItem: {
    //         border: '1px double #ccc',
    //         borderRadius: '30px',
    //         padding: '16px',
    //         marginBottom: '16px',
    //         boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
    //         width: '1000px',
    //         backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 1.5), backdropFilter: "saturate(200%) blur(30px)", boxShadow: ({ boxShadows: { xxl } }) => xxl,
    //     },
    //     trainingInfo: {
    //         display: 'flex',
    //         flexDirection: 'column',
    //     },
    //     trainingName: {
    //         marginTop: '-10px',
    //         marginBottom: '8px',
    //         fontSize: 'medium',
    //         color: 'rgb(60, 150, 190)'
    //     },
    //     gridContent: {
    //         padding: '13px',
    //     },
    // };
    const [search, setSearch] = useState("");
    const [modeOfTraining, setModeOfTraining] = useState("");
    const [classroomLocation, setClassroomLocation] = useState("");
    const [budget, setBudget] = useState("");
    const [budgetRangeFrom, setBudgetRangeFrom] = useState("");
    const [budgetRangeTo, setBudgetRangeTo] = useState("");
    const [commercialsLessThan4hrs, setCommercialsLessThan4hrs] = useState("");
    const [commercials4hrs, setCommercials4hrs] = useState("");
    const [commercials8hrs, setCommercials8hrs] = useState("");
    const [lab, setLab] = useState("");
    const [labCostPerParticipants, setLabCostPerParticipants] = useState("");
    const [serverCount, setServerCount] = useState("");
    const [typeOfServer, setTypeOfServer] = useState("");
    const [courseDuration, setCourseDuration] = useState("");
    const [lastClient, setLastClient] = useState("");
    const [trainingComment, settrainingComment] = useState("");
    const [selectedTrainingCompanyId, setSelectedTrainingCompanyId] = useState("");
    const [selectedTraining, setSelectedTraining] = useState('');
    const [showLocationField, setShowLocationField] = useState(false);
    const [skillsName, setSkillsName] = useState([]);
    const [trainingList, setTrainingList] = useState([]);
    const [bbdata, setbbData] = useState([]);
    const [tocAvailable, setTocAvailable] = useState("");
    const [proposalState, setProposalState] = useState("");
    const [labNeeded, setLabNeeded] = useState("");
    const [trainingTiming, setTrainingTiming] = useState("");
    const [trainingType, setTrainingType] = useState("");
    const [audienceLevel, setAudienceLevel] = useState("");
    const [trainingExpectation, setTrainingExpectation] = useState("");
    const [fromDuration, setFromDuration] = useState("");
    const [toDuration, setToDuration] = useState("");
    const [timeZone, setTimeZone] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const pageSize = 5;
    const itemsPerPage = 5;
    const [currentPage, setCurrentPage] = useState(1);

    const [minParticipants, setMinParticipants] = React.useState("");
    const [maxParticipants, setMaxParticipants] = React.useState("");

    const handleSliderChange = (event, newValues) => {
        const [minValue, maxValue] = newValues;
        setMinParticipants(minValue);
        setMaxParticipants(maxValue);
    };

    console.log("minParticipants", minParticipants);
    console.log("maxParticipants", maxParticipants);

    const handleDurationSliderChange = (event, newValues) => {
        const [minValue, maxValue] = newValues;
        setFromDuration(minValue);
        setToDuration(maxValue);
    };

    const fromDurationOptions = Array.from({ length: 4 }, (_, index) => (index + 1) * 5);
    const toDurationOptions = Array.from({ length: 10 }, (_, index) => (index + 1) * 5);

    const minParticipantsOptions = Array.from({ length: 10 }, (_, index) => index);
    const maxParticipantsOptions = Array.from({ length: 51 }, (_, index) => index);

    const timeZones = moment.tz.names();

    const handleTimeZoneChange = (newValue) => {
        setTimeZone(newValue);
    };
    console.log("timeZone", timeZone);

    const today = new Date().toISOString().split('T')[0];

    const handleFromDateChange = (e) => {
        setFromDate(e.target.value);
    };
    console.log("fromDate", fromDate);

    const handleToDateChange = (e) => {
        setToDate(e.target.value);
    };
    console.log("toDate", toDate);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/api/skill-details/`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + localStorage.getItem("token"),
            },
        })
            .then((resp) => resp.json())
            .then((data) => {
                if (data.detail) {
                } else {
                    setSkillsName(data);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);
    console.log("skillsName", skillsName);

    const onSubmitClick = async () => {
        const filteredList = filterTrainingList();
        setTrainingList(filteredList);
    };

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/api/training-page-less/?totalTrainingBudget__gte=${budgetRangeFrom}&totalTrainingBudget__lte=${budgetRangeTo}&trainingMode__icontains=${modeOfTraining}&technology__icontains=${search}&trainingLocations=${classroomLocation}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        })
            .then((resp) => resp.json())
            .then((data) => {
                if (!data.detail) {
                    setbbData(data);
                    setTrainingList(data);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }, [modeOfTraining, budget, search, classroomLocation]);

    console.log("trainingList", trainingList);
    console.log("data", bbdata);

    const totalPages = Math.ceil(trainingList.length / pageSize);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const asearch = queryParams.get('search');
    const amodeOfTraining = queryParams.get('modeOfTraining');
    const aclassroomLocation = queryParams.get('classroomLocation');

    console.log("hi");
    console.log("search", asearch);
    console.log("modeOfTraining", amodeOfTraining);
    console.log("classroomLocation", aclassroomLocation);


    useEffect(() => {
        if (asearch !== search) {
            setSearch(asearch);
        }

        if (amodeOfTraining !== modeOfTraining) {
            setModeOfTraining(amodeOfTraining);
        }

        if (aclassroomLocation !== classroomLocation) {
            setClassroomLocation(aclassroomLocation);
        }
    }, [asearch, amodeOfTraining, aclassroomLocation]);


    const onClearFilterClick = () => {
        setSearch("");
        setBudget("");
        setBudgetRangeFrom("");
        setBudgetRangeTo("");
        setModeOfTraining("");
        setClassroomLocation("");
        setShowLocationField(false);
        setTocAvailable("");
        setFromDate("");
        setToDate("");
        setFromDuration("");
        setToDuration("");
        setProposalState("");
        setMinParticipants("");
        setMaxParticipants("");
        setTrainingTiming("");
        setTimeZone("");
        setTrainingType("");
        setLabNeeded("");
        setAudienceLevel("");
        setTrainingExpectation("");
    };

    console.log("selectedTraining", selectedTraining);
    console.log("selectedTrainingCompanyId", selectedTrainingCompanyId);

    const handleSearchChange = (event, value) => {
        setSearch(value);
    };
    console.log("search", search);
    console.log("commercialsLessThan4hrs", commercialsLessThan4hrs);
    console.log("commercials4hrs", commercials4hrs);
    console.log("commercials8hrs", commercials8hrs);
    console.log("serverCount", serverCount);
    console.log("typeOfServer", typeOfServer);
    console.log("labCostPerParticipants", labCostPerParticipants);
    console.log("courseDuration", courseDuration);
    console.log("lastClient", lastClient);
    console.log("trainingComment", trainingComment);

    console.log("proposal state", proposalState);
    console.log("toc", tocAvailable);
    console.log("lab", labNeeded);


    const handleBudgetChange = (e) => {
        const newValue = e.target.value;
        setBudget(newValue);
        if (newValue === "0-1000") {
            setBudgetRangeFrom(0);
            setBudgetRangeTo(1000);
        } else if (newValue === "1000-5000") {
            setBudgetRangeFrom(1000);
            setBudgetRangeTo(5000);
        } else if (newValue === "5000-10000") {
            setBudgetRangeFrom(5000);
            setBudgetRangeTo(10000);
        } else if (newValue === "10000-20000") {
            setBudgetRangeFrom(10000);
            setBudgetRangeTo(20000);
        } else if (newValue === ">20000") {
            setBudgetRangeFrom(20000);
        }
    };

    console.log("budget", budget);
    console.log("budgetRangeFrom", budgetRangeFrom);
    console.log("budgetRangeTo", budgetRangeTo);

    const handlePreferredModeChange = (e) => {
        const selectedMode = e.target.value;
        setModeOfTraining(selectedMode);

        if (selectedMode === "Classroom") {
            setShowLocationField(true);
        } else {
            setShowLocationField(false);
        }
    };
    console.log("modeOfTraining", modeOfTraining);

    const filterTrainingList = () => {
        return trainingList.filter((training) => {
            const tocAvailableMatch = !tocAvailable || training.tocAvailable === tocAvailable;
            const proposalStateMatch = !proposalState || training.trainingProposalState === proposalState;
            const labNeededMatch = !labNeeded || training.labNeededForTraining === labNeeded;
            const trainingTimingMatch = !trainingTiming || training.trainingTiming === trainingTiming;
            const audienceLevelMatch = !audienceLevel || training.audienceLevel === audienceLevel;
            const trainingExpectationMatch = !trainingExpectation || training.trainingExpectation === trainingExpectation;
            const minParticipantsMatch = !minParticipants || training.totalParticipants >= minParticipants;
            const maxParticipantsMatch = !maxParticipants || training.totalParticipants <= maxParticipants;
            const fromDurationMatch = !fromDuration || training.duration >= fromDuration;
            const toDurationMatch = !toDuration || training.duration <= toDuration;
            const fromDateMatch = !fromDate || training.expectedStartDate >= fromDate;
            const toDateMatch = !toDate || training.expectedStartDate <= toDate;
            const timeZoneMatch = !timeZone || training.timeZone.includes(timeZone);

            return (
                tocAvailableMatch &&
                proposalStateMatch &&
                labNeededMatch &&
                trainingTimingMatch &&
                audienceLevelMatch &&
                trainingExpectationMatch &&
                minParticipantsMatch &&
                maxParticipantsMatch &&
                fromDurationMatch &&
                toDurationMatch &&
                fromDateMatch &&
                toDateMatch &&
                timeZoneMatch
            );
        });
    };

    const navigate = useNavigate();

    const onMoreDetailsClick = (training) => {
        console.log("training1111111", training);
        console.log("token111111111", localStorage.getItem("token"));
        if (localStorage.getItem("token") !== "" || localStorage.getItem("token") !== null) {
            console.log("helloooooooooooooo");
            navigate('/pages/authentication/trainersign-in', { state: { redirectUrl: `/app/trainingDetails/${training.id}/` } });
        } else {
            console.log("aaaaaaaaaaaaaaaaaaaaa");
            navigate(`/app/trainingDetails/${training.id}/`);
        }

    };

    const getCurrentPageData = () => {
        const startIndex = (currentPage - 1) * pageSize;
        const endIndex = startIndex + pageSize;
        return filterTrainingList().slice(startIndex, endIndex);
    };

    const handleNextClick = () => {
        const totalPages = Math.ceil(filterTrainingList().length / pageSize);
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrevClick = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };


    return (
        <>
            <DefaultNavbar
                routes={routes}
                sticky
            />
            <Card
                sx={{
                    height: 'auto',
                    p: 2,
                    mx: { xs: 2, lg: 3 },
                    mt: -8,
                    mb: 4,
                    // backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
                    backdropFilter: "saturate(200%) blur(30px)",
                    boxShadow: ({ boxShadows: { xxl } }) => xxl,
                }}
            >
                <Container maxWidth="sm">
                    <form>
                        <Grid container style={{ marginTop: "130px" }} spacing={2}>
                            <Grid item xs={12} sm={3}>
                                <MKTypography style={{ whiteSpace: 'nowrap' }} variant="h2" color="text">
                                    <span style={{ color: 'black' }}>Search</span>{' '}
                                    <span style={{ color: 'rgb(60, 150, 190)' }}>Trainings</span>
                                </MKTypography>
                            </Grid>
                        </Grid>
                        <Grid container style={{ marginTop: '20px' }} >
                            <Grid item xs={12} sm={9}>
                                <div>
                                    <Typography variant="h5" style={{ color: 'black' }}>Search by Skills</Typography>
                                    <Autocomplete
                                        id="skills"
                                        options={skillsName}
                                        freeSolo
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Skill"
                                                variant="standard"
                                                style={{ marginTop: '10px' }}
                                                fullWidth
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <SearchIcon fontSize="medium" />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        )}
                                        onChange={(event, value) => handleSearchChange(event, value)}
                                    />
                                </div>
                            </Grid>
                        </Grid>

                        <Container>
                            <Grid container>
                                <Grid item xs={4} style={{ marginLeft: '-50px' }}>
                                    <div style={sidebarStyles}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Typography variant="h5" style={{ color: 'black', marginLeft: '8px' }}>Filters</Typography>
                                            {/* <Link href="#" onClick={onClearFilterClick} style={{ marginLeft: '65px', textDecoration: 'underline', color: 'blue', cursor: 'pointer', fontSize: 'small' }}>
                                                Clear Filters
                                            </Link> */}
                                            <MKButton variant="gradient" color="info" size="small" style={{ marginLeft: '65px', whiteSpace: 'nowrap' }} onClick={onClearFilterClick} >Clear Filters</MKButton>
                                            <MKButton variant="gradient" color="info" size="small" style={{ marginRight: '10px' }} onClick={onSubmitClick} >Submit</MKButton>
                                        </div>
                                        <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                            <FormControl variant="outlined" style={{ flex: 1 }}>
                                                <InputLabel id="preferred-mode-label">Mode Of Training</InputLabel>
                                                <Select
                                                    labelId="preferred-mode-label"
                                                    label="Mode Of Training"
                                                    fullWidth
                                                    onChange={handlePreferredModeChange}
                                                    value={modeOfTraining}
                                                    style={{ minHeight: '44px' }}
                                                >
                                                    <MenuItem value="Virtual">Virtual</MenuItem>
                                                    <MenuItem value="Classroom">Classroom</MenuItem>
                                                </Select>
                                            </FormControl>

                                        </div>
                                        {showLocationField === true && modeOfTraining === 'Classroom' && (
                                            <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                                <TextField
                                                    label="Location"
                                                    variant="gradient"
                                                    fullWidth
                                                    style={{ flex: 1 }}
                                                    value={classroomLocation}
                                                    onChange={(e) => setClassroomLocation(e.target.value)}
                                                />
                                            </div>
                                        )}
                                        <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                            <FormControl variant="outlined" style={{ flex: 1 }}>
                                                <InputLabel id="budget">Budget</InputLabel>
                                                <Select
                                                    labelId="budget"
                                                    label="Budget"
                                                    fullWidth
                                                    onChange={handleBudgetChange}
                                                    value={budget}
                                                    style={{ minHeight: '44px' }}
                                                >
                                                    <MenuItem value="0-1000">0-1000</MenuItem>
                                                    <MenuItem value="1000-5000">1000-5000</MenuItem>
                                                    <MenuItem value="5000-10000">5000-10000</MenuItem>
                                                    <MenuItem value="10000-20000">10000-20000</MenuItem>
                                                    <MenuItem value="&gt;20000">&gt;20000</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                            <FormControl variant="outlined" fullWidth>
                                                <InputLabel id="toc-available-label">TOC Available</InputLabel>
                                                <Select
                                                    labelId="toc-available-label"
                                                    label="TOC Available"
                                                    fullWidth
                                                    onChange={(e) => setTocAvailable(e.target.value)}
                                                    value={tocAvailable}
                                                    style={{ minHeight: '44px' }}
                                                >
                                                    <MenuItem value="">Select</MenuItem>
                                                    <MenuItem value="yes">Yes</MenuItem>
                                                    <MenuItem value="no">No</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                            <FormControl variant="outlined" fullWidth>
                                                <InputLabel id="proposal-state-label">
                                                    Training Proposal State
                                                </InputLabel>
                                                <Select
                                                    labelId="proposal-state-label"
                                                    label="Training Proposal State"
                                                    fullWidth
                                                    onChange={(e) => setProposalState(e.target.value)}
                                                    value={proposalState}
                                                    style={{ minHeight: '44px' }}
                                                >
                                                    <MenuItem value="">Select</MenuItem>
                                                    <MenuItem value="Confirmed">Confirmed</MenuItem>
                                                    <MenuItem value="Biding">Biding</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                            <FormControl variant="outlined" fullWidth>
                                                <InputLabel id="training-type-label">Training Type</InputLabel>
                                                <Select
                                                    labelId="training-type-label"
                                                    label="Training Type"
                                                    fullWidth
                                                    onChange={(e) => setTrainingType(e.target.value)}
                                                    value={trainingType}
                                                    style={{ minHeight: '44px' }}
                                                >
                                                    <MenuItem value="">Select</MenuItem>
                                                    <MenuItem value="Corporate">Corporate</MenuItem>
                                                    <MenuItem value="Individual">Individual</MenuItem>
                                                    <MenuItem value="Public Batch">Public Batch</MenuItem>
                                                    <MenuItem value="College Seminars">College Seminars</MenuItem>
                                                    <MenuItem value="Public Seminars">Public Seminars</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </div>
                                        {/* <MKButton variant="gradient" color="info" size="small" style={{ marginLeft: '10px' }} onClick={onSubmitClick} >Submit</MKButton> */}
                                        <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                            <FormControl variant="outlined" fullWidth>
                                                <InputLabel id="training-timing-label">Training Timing</InputLabel>
                                                <Select
                                                    labelId="training-timing-label"
                                                    label="Training Timing"
                                                    fullWidth
                                                    onChange={(e) => setTrainingTiming(e.target.value)}
                                                    value={trainingTiming}
                                                    style={{ minHeight: '44px' }}
                                                >
                                                    <MenuItem value="">Select</MenuItem>
                                                    <MenuItem value="4 hours">4 hours</MenuItem>
                                                    <MenuItem value="8 hours">8 hours</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                            <FormControl variant="outlined" fullWidth>
                                                <InputLabel id="audience-level-label">
                                                    Audience Level
                                                </InputLabel>
                                                <Select
                                                    labelId="audience-level-label"
                                                    label="Audience Level"
                                                    fullWidth
                                                    onChange={(e) => setAudienceLevel(e.target.value)}
                                                    value={audienceLevel}
                                                    style={{ minHeight: '44px' }}
                                                >
                                                    <MenuItem value="">Select</MenuItem>
                                                    <MenuItem value="Fresher">Fresher</MenuItem>
                                                    <MenuItem value="Lateral">Lateral</MenuItem>
                                                    <MenuItem value="Not Known">Not Known</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                            <FormControl variant="outlined" fullWidth>
                                                <InputLabel id="training-expectation-label">Training Expectation</InputLabel>
                                                <Select
                                                    labelId="training-expectation-label"
                                                    label="Training Expectation"
                                                    fullWidth
                                                    onChange={(e) => setTrainingExpectation(e.target.value)}
                                                    value={trainingExpectation}
                                                    style={{ minHeight: '44px' }}
                                                >
                                                    <MenuItem value="">Select</MenuItem>
                                                    <MenuItem value="Beginners">Beginners</MenuItem>
                                                    <MenuItem value="Intermediate">Intermediate</MenuItem>
                                                    <MenuItem value="Experienced">Experienced</MenuItem>
                                                    <MenuItem value="Not Known">Not Known</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                            <Autocomplete
                                                // multiple
                                                id="timeZone-autocomplete"
                                                options={timeZones}
                                                freeSolo
                                                renderTags={(value, getTagProps) =>
                                                    value.map((option, tagIndex) => (
                                                        <span key={tagIndex} {...getTagProps({ index: tagIndex })}>
                                                            {option}
                                                        </span>
                                                    ))
                                                }
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Working Time Zone"
                                                        variant="gradient"
                                                        style={{ minHeight: '40px', width: '290px' }}
                                                        fullWidth
                                                    />
                                                )}
                                                onChange={(_event, value) => handleTimeZoneChange(value)}
                                            />
                                        </div>
                                        {/* <MKButton variant="gradient" color="info" size="small" style={{ marginLeft: '10px' }} onClick={onSubmitClick} >Submit</MKButton> */}
                                        <Typography style={{ marginLeft: '10px' }} variant="h6">Duration of Training (in hours)</Typography>
                                        <div style={{ marginTop: '10px', marginLeft: '10px', padding: '10px' }}>
                                            <Slider
                                                value={[fromDuration, toDuration]}
                                                onChange={handleDurationSliderChange}
                                                size="small"
                                                getAriaValueText={valuetext}
                                                valueLabelDisplay="auto"
                                                aria-labelledby="range-slider"
                                            />
                                        </div>
                                        <div style={{ marginLeft: '10px', adding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                            <TextField
                                                label="Min"
                                                variant="gradient"
                                                style={{ width: '100px' }}
                                                fullWidth
                                                onChange={(e) => setFromDuration(e.target.value)}
                                                value={fromDuration}
                                                InputProps={{ inputProps: { min: 0, max: 100 } }}
                                                type="number"
                                            />
                                            <TextField
                                                label="Max"
                                                variant="gradient"
                                                style={{ marginRight: '10px', width: '100px' }}
                                                fullWidth
                                                onChange={(e) => setToDuration(e.target.value)}
                                                value={toDuration}
                                                InputProps={{ inputProps: { min: 0, max: 100 } }}
                                                type="number"
                                            />
                                        </div>
                                        <Typography style={{ marginLeft: '10px', marginRight: '20px', marginTop: '10px' }} variant="h6">Total Participants</Typography>
                                        <div style={{ marginLeft: '10px', marginTop: '10px', padding: '10px' }}>
                                            <Slider
                                                value={[minParticipants, maxParticipants]}
                                                onChange={handleSliderChange}
                                                size="small"
                                                getAriaValueText={valuetext}
                                                valueLabelDisplay="auto"
                                                aria-labelledby="range-slider"
                                            />
                                        </div>
                                        <div style={{ marginLeft: '10px', adding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                            <TextField
                                                label="Min"
                                                variant="gradient"
                                                style={{ width: '100px' }}
                                                fullWidth
                                                onChange={(e) => setMinParticipants(e.target.value)}
                                                value={minParticipants}
                                                InputProps={{ inputProps: { min: 0, max: 100 } }}
                                                type="number"
                                            />
                                            <TextField
                                                label="Max"
                                                variant="gradient"
                                                style={{ marginRight: '10px', width: '100px' }}
                                                fullWidth
                                                onChange={(e) => setMaxParticipants(e.target.value)}
                                                value={maxParticipants}
                                                InputProps={{ inputProps: { min: 0, max: 100 } }}
                                                type="number"
                                            />
                                        </div>
                                        <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                        </div>
                                        <Typography style={{ marginLeft: '10px', marginTop: '-10px', marginRight: '20px' }} variant="h6">Expected Start Date</Typography>
                                        <div style={{ marginTop: '10px', padding: '10px', display: 'flex' }}>
                                            <div>
                                                <InputLabel style={{ marginLeft: '5px', marginTop: "-18px", marginBottom: "-5px" }} shrink={true}>From Date</InputLabel>
                                            </div>
                                            <MKInput
                                                type="date"
                                                id="from_date"
                                                value={fromDate || ""}
                                                onChange={handleFromDateChange}
                                                style={{ minHeight: '44px', width: '300px', marginLeft: '-80px' }}
                                                placeholder="From Date"
                                                // inputProps={{ max: today }}
                                                fullwidth
                                            />
                                        </div>
                                        <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                            <div>
                                                <InputLabel style={{ marginLeft: '5px', marginTop: "-18px", marginBottom: "-5px" }} shrink={true}>To Date</InputLabel>
                                            </div>
                                            <MKInput
                                                type="date"
                                                id="to_date"
                                                value={toDate || ""}
                                                onChange={handleToDateChange}
                                                style={{ minHeight: '44px', width: '300px', marginLeft: '-60px' }}
                                                placeholder="To Date"
                                                // inputProps={{ max: today }}
                                                fullwidth
                                            />
                                        </div>

                                    </div>
                                </Grid>

                                <Grid item xs={8}>
                                    <Grid container style={{ marginTop: '10px', marginBottom: '10px' }} spacing={2}>
                                        <Grid item xs={12} sm={3}>
                                            <MKTypography style={{ whiteSpace: 'nowrap' }} variant="h6" color="black">
                                                {filterTrainingList() ? `${filterTrainingList().length} result${filterTrainingList().length !== 1 ? 's' : ''} found` : 'Default Training Name'}
                                            </MKTypography>
                                        </Grid>
                                    </Grid>
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        {/* {filterTrainingList().map((training, index) => ( */}
                                        {getCurrentPageData().map((training, index) => (
                                            <Grid item xs={8} key={training.id} className="gridItem">
                                                <div className="gridContent">
                                                    <div className="trainingInfo">
                                                        <Typography variant="subtitle1" className="trainingName" ><strong>{training.trainingName}</strong></Typography>
                                                        <Typography style={{ fontSize: 'medium' }}>
                                                            <span style={{ display: 'flex', alignItems: 'center' }}>
                                                                <img src={Logo} alt="Skills Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} /> {training.technology}
                                                            </span>
                                                        </Typography>
                                                        <Typography style={{ fontSize: 'medium' }}>
                                                            <span style={{ display: 'flex', alignItems: 'center' }}>
                                                                <img src={CompanyIcon} alt="Company Icon" style={{ marginRight: '5px', width: '20px', height: '20px' }} />
                                                                {training.trainingCompanyName}&nbsp;|

                                                                {training.trainingMode === 'Virtual' && (
                                                                    <img src={VirtualIcon} alt="Virtual Icon" style={{ marginRight: '5px', width: '20px', height: '20px' }} />
                                                                )}

                                                                {training.trainingMode === 'Classroom' && (
                                                                    <img src={ClassroomIcon} alt="Classroom Icon" style={{ marginRight: '5px', width: '20px', height: '20px' }} />
                                                                )} {training.trainingMode}

                                                                {training.trainingMode === 'Classroom' && (
                                                                    <>
                                                                        {' | '}
                                                                        <LocationOn style={{ marginRight: '5px' }} />
                                                                        {training.trainingLocations}
                                                                    </>
                                                                )}
                                                            </span>
                                                        </Typography>
                                                        <Typography style={{ fontSize: 'medium' }}>
                                                            <span style={{ display: 'flex', alignItems: 'center' }}>
                                                                {training.currency}&nbsp;{training.totalTrainingBudget} |&nbsp;<img src={Expectation} alt="Expectation Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} /> {training.trainingExpectation}
                                                            </span>
                                                        </Typography>
                                                        <Typography style={{ fontSize: 'medium' }}>
                                                            <span style={{ display: 'flex', alignItems: 'center' }}>
                                                                <CalendarMonthIcon style={{ marginRight: '5px' }} /> {training.expectedStartDate}
                                                            </span>
                                                        </Typography>
                                                    </div>
                                                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-50px' }}>
                                                        <MKButton variant="gradient" color="info" size="small" onClick={() => onMoreDetailsClick(training)} style={{ padding: '5px 10px' }}>Details</MKButton>
                                                    </div>
                                                </div>
                                            </Grid>
                                        ))}
                                        <div style={{ marginTop: '10px', marginLeft: '-280px', display: 'flex', justifyContent: 'center' }}>
                                            <MKButton onClick={handlePrevClick} color="info" variant="gradient" size="small" disabled={currentPage === 1}>
                                                <Icon>keyboard_arrow_left</Icon>
                                            </MKButton>
                                            {Array.from({ length: totalPages }).map((_, index) => (
                                                <MKButton
                                                    key={index}
                                                    onClick={() => setCurrentPage(index + 1)}
                                                    variant={currentPage === index + 1 ? 'contained' : 'outlined'}
                                                    color="info"
                                                    size="small"
                                                >
                                                    {index + 1}
                                                </MKButton>
                                            ))}
                                            <MKButton onClick={handleNextClick} variant="gradient" color="info" size="small" disabled={currentPage === totalPages}>
                                                <Icon>keyboard_arrow_right</Icon>
                                            </MKButton>
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                        </Container>
                    </form>
                </Container>
            </Card>
            <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <MKBox position="center" zIndex={2} style={{ bottom: 0 }}>
                    <SimpleFooter />
                </MKBox>
            </div>
        </>
    );
}

export default Page;